module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a-dropdown', {
    staticStyle: {
      "display": "inline-block",
      "height": "100%",
      "vertical-align": "initial"
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('a-avatar', {
    staticClass: "avatar",
    attrs: {
      "size": "small",
      "shape": "circle",
      "src": _vm.avatar,
      "alt": "头像",
      "loadError": function () { return false; }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "curr-user"
  }, [_vm._v(_vm._s(_vm.user.userName))])], 1), _vm._v(" "), _c('a-menu', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "slot": "overlay"
    },
    slot: "overlay"
  }, [_c('a-menu-item', {
    on: {
      "click": _vm.openProfile
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "user"
    }
  }), _vm._v(" "), _c('span', [_vm._v("个人中心")])], 1), _vm._v(" "), _c('a-menu-item', {
    on: {
      "click": _vm.updatePassword
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "key"
    }
  }), _vm._v(" "), _c('span', [_vm._v("密码修改")])], 1), _vm._v(" "), _c('a-menu-divider'), _vm._v(" "), _c('a-menu-item', {
    on: {
      "click": _vm.handleSettingClick
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "setting"
    }
  }), _vm._v(" "), _c('span', [_vm._v("系统定制")])], 1), _vm._v(" "), _c('a-menu-divider'), _vm._v(" "), _c('a-menu-item', {
    on: {
      "click": _vm.logout
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "logout"
    }
  }), _vm._v(" "), _c('span', [_vm._v("退出登录")])], 1)], 1)], 1), _vm._v(" "), _c('update-password', {
    attrs: {
      "user": _vm.user,
      "updatePasswordModelVisible": _vm.updatePasswordModelVisible
    },
    on: {
      "success": _vm.handleUpdate,
      "cancel": _vm.handleCancelUpdate
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-575dc8d3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/common/HeaderAvatar.vue
// module id = dHQr
// module chunks = 273